import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { BiddingNowPopupComponent } from '../bidding-now-popup/bidding-now-popup.component';
import { BuyerService } from '../../../_services/buyer/buyer.service';
import {} from '../../../../../Shared/_services/terms-and-conditions/terms-and-conditions.service';
import { TermsConditionsUpdatedPopupComponent } from '../terms-conditions-updated-popup/terms-conditions-updated-popup.component';
import { BehaviorSubject } from 'rxjs';
import { TermsAndConditionsAcceptanceService } from '../../services/terms-and-conditions-acceptance.service';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

@Component({
  selector: 'app-bid-now-button',
  standalone: true,
  imports: [NgIf, NgClass, MatIconModule, TranslatePipe],
  templateUrl: './bid-now-button.component.html',
  styleUrl: './bid-now-button.component.scss',
})
export class BidNowButtonComponent {
  constructor(
    private dialog: MatDialog,
    private buyerService: BuyerService,
    private termsAcceptance: TermsAndConditionsAcceptanceService,
    private cdr: ChangeDetectorRef
  ,
    public localeService: LocaleService
  ) {}
  @Input() condition: any;
  @Input() dir: any;
  @Input() elementId: any;
  @Input() slug: any;
  @Input() isDisabled: boolean = false;
  @Input() classStyle: string = '';
  @Input() isGuest!: boolean;
  @Input() terms: any;
  @Input() buyerStatus: any;
  @Input() sellerEmail: string = '';

  get isBlocked(): boolean {
    return this.buyerStatus?.is_blocked ?? false;
  }

  get isSuspended(): boolean {
    return this.buyerStatus?.is_suspended ?? false;
  }

  get isBlockedOrSuspended(): boolean {
    return this.isBlocked || this.isSuspended;
  }

  buyerAccepted$ = this.termsAcceptance.buyerAccepted$; // Observable exposed by the service

  bidNowClicked(event: any) {
    event.stopPropagation();

    if (this.isGuest == undefined || this.isGuest === true) {
      if (
        this.terms?.buyer_accepted === 'not accepted' &&
        this.terms?.seller_terms
      ) {
        this.openAcceptTermsConditions();
      } else {
        this.openBidNowPopup();
      }
    } else {
      this.buyerService.setShowLogin(true);
    }
  }

  openAcceptTermsConditions(): void {
    const dialogRef = this.dialog.open(TermsConditionsUpdatedPopupComponent, {
      width: '630px',
      panelClass: ['buyer-theme'],
      direction: this.localeService.dir,
      data: this.terms,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data?.accepted == 1) {
        this.terms.buyer_accepted = 'accepted';
        this.termsAcceptance.setBuyerAccepted({
          isAccepted: 'accepted',
          auctionId: result?.data?.auction_id,
        });
        this.openBidNowPopup();
        this.cdr.detectChanges();
      }
    });
  }
  openBidNowPopup(): void {
    this.dialog.open(BiddingNowPopupComponent, {
      width: '850px',
      height: '575px',
      panelClass: ['buyer-theme'],
      direction: this.localeService.dir,

      data: { slug: this.slug },
    });
  }
}
